
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'iconButton': {'zIndex': `130`,'position': `fixed`,'backgroundColor': `#9b9b9b`,'color': `#000`,'&:hover': {
          'transition': `0.3s`,'color': `#000`,'backgroundColor': `#ffffff`,
        },},
        
      };
    };
  